module.exports = __webpack_public_path__ + "img/organizations_black.6bb07227.svg";